import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useActionNotDone } from "../../hooks/useCrm";

export const ActionNoteDoneModal = ({ show, handleClose, activityId }) => {
  const [button] = useState(false);
  const { mutateAsync: ActionToNotDone } = useActionNotDone();
  const handleActionNotDone = async (id) => {
    await ActionToNotDone({ IdActivityCrm: id });
  };
  return (
    <BootstrapModal
      modaltitle="تبدیل به انجام نشده"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy className="mb-4">
            آیا از تبدیل وضعیت فعالیت به انجام نشده مطمئنید؟
          </Typogaphy>
        </div>
        <div className="col-12 d-flex">
          <Button
            bgColor="#009ef7"
            className="m-1"
            color="#fff"
            onclick={() => {
              handleActionNotDone(activityId);
              handleClose();
            }}
          >
            بله
          </Button>
          <Button
            bgColor="#f1416c"
            className="m-1"
            color="#fff"
            onclick={handleClose}
          >
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
